import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { getProcedureViewData } from '@/utils/procedure';

export const procedureViewRoute: RouteConfig = {
  path: 'view',
  name: 'procedureView',
  component: () => import(/* webpackChunkName: "ProcedureView" */ '@/views/mainRoute/procedure/details/View.vue'),
  beforeEnter: (to, from, next) => {
    store.commit('procedure/setId', tryParseInt(to.params.procedureId));
    getProcedureViewData(to)
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.PROCEDURE_CANNOT_GET }));
  }
};
